import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['panel', 'overlay', 'openButton'];

  declare readonly panelTarget: HTMLElement;
  declare readonly overlayTarget: HTMLElement;
  declare readonly openButtonTarget: HTMLElement;

  open() {
    this.panelTarget.classList.remove('-tw-translate-x-full');
    this.panelTarget.classList.add('tw-translate-x-0');
    this.overlayTarget.classList.remove('tw-hidden');
    this.openButtonTarget.classList.add('tw-hidden');
  }

  close() {
    this.panelTarget.classList.add('-tw-translate-x-full');
    this.panelTarget.classList.remove('tw-translate-x-0');
    this.overlayTarget.classList.add('tw-hidden');
    this.openButtonTarget.classList.remove('tw-hidden');
  }
}
